import React, { useEffect, useState } from 'react';
import { useDeliverymen } from '~/hooks/deliverymens';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';

type Props = {
  orders: IOrder[];
};

export function DeliveryFeeDetails({ orders }: Props): JSX.Element {
  const { deliverymens, loadDeliverymens } = useDeliverymen();

  const [fee, setFee] = useState({} as any);

  useEffect(() => {
    if (deliverymens === null) {
      loadDeliverymens();
    }
  }, [deliverymens, loadDeliverymens]);

  useEffect(() => {
    if (orders.length > 0) {
      const values = {} as any;

      orders.forEach(order => {
        if (order.deliverymen) {
          if (!values[order.deliverymen]) {
            values[order.deliverymen] = 0;
          }

          values[order.deliverymen] += order.shippingCost;
        }
      });

      setFee(values);
    }
  }, [orders]);

  return (
    <div className="col-xl-8 offset-xl-2 mt-4">
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <div className="nk-block-head-content w-100 d-flex justify-content-between">
            <h6 className="nk-block-title">Detalhamento Taxa de Entrega</h6>
          </div>
        </div>
      </div>
      <div className="nk-block">
        <div className="card card-bordered">
          <div className="card-inner-group">
            <div className="card-inner p-0">
              <div className="nk-tb-list">
                <div className="nk-tb-item nk-tb-head">
                  <div className="nk-tb-col">
                    <span>Entregador</span>
                  </div>
                  <div className="nk-tb-col">
                    <span>Valor</span>
                  </div>
                </div>

                {deliverymens &&
                  deliverymens?.map(item => (
                    <div className="nk-tb-item" key={item.uid}>
                      <div className="nk-tb-col">
                        <span className="tb-product">{item.name}</span>
                      </div>
                      <div className="nk-tb-col">
                        <span className="tb-product">
                          {getCurrencyFormatted(fee[item.uid] || 0)}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
